module.exports = __webpack_public_path__ + "img/k.380a152b.png";